<div normal>
    <modal-default-mmaxapp>
        <div class="tarjetamensaje">
            <div class="titulo">
                {{title}}
            </div>
            <div class="leyendamensaje" [innerHTML]="message">
            </div>
            <div class="botncontainer">
                <button class="noselect btons blubutton" (click)="cerrar()">Aceptar</button>
            </div>
        </div>
    </modal-default-mmaxapp>
</div>